const mainStyles = {
  rowWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    flex: 'wrap'
  },
  switchWrapper: {
    display: 'flex',
    marginLeft: 120
  }
}

export { mainStyles }
